/* global cv */
let src = null;
let dstC1 = null;
let dstC3 = null;
let dstC3_ = null;
let dstC4 = null;
let vDstC3 = null;
let videoWidth;
let videoHeight;
let width;
let height;
let firstDetection;

/*
    Zeige Video in voller Auflösung ohne erkannte Konturen oder in verringerter Auflösung mit erkannten Konturen
*/
const showHighResVideo = true;

const minSizeFactor = 0.05;
const areaFactor = 0.8;
const contourColor = [255, 0, 0, 0];

const detectedGrids = [
    {x: 5, y: 3, wh: 13/9.0}, //wh = width / height - factor
    {x: 4, y: 3, wh: 12.5/6.5}, //wh = width / height - factor
    {x: 4, y: 2, wh: 11.5/4.5},
]

function drawFocusRect(dest, r) {
    const lineLen = r.width * 0.05;
    const color = [0, 0, 0, 0];


    cv.line(dest, 
        new cv.Point(r.x, r.y),
        new cv.Point(r.x + lineLen, r.y),
        color,
        2
    );
    cv.line(dest, 
        new cv.Point(r.x, r.y),
        new cv.Point(r.x, r.y + lineLen),
        color,
        2
    );

    cv.line(dest, 
        new cv.Point(r.x + r.width, r.y),
        new cv.Point(r.x + r.width - lineLen, r.y),
        color,
        2
    );
    cv.line(dest, 
        new cv.Point(r.x + r.width, r.y),
        new cv.Point(r.x + r.width, r.y + lineLen),
        color,
        2
    );

    cv.line(dest, 
        new cv.Point(r.x, r.y + r.height),
        new cv.Point(r.x + lineLen, r.y + r.height),
        color,
        2
    );
    cv.line(dest, 
        new cv.Point(r.x, r.y + r.height),
        new cv.Point(r.x, r.y + r.height - lineLen),
        color,
        2
    );

    cv.line(dest, 
        new cv.Point(r.x + r.width, r.y + r.height),
        new cv.Point(r.x + r.width - lineLen, r.y + r.height),
        color,
        2
    );
    cv.line(dest, 
        new cv.Point(r.x + r.width, r.y + r.height),
        new cv.Point(r.x + r.width, r.y + r.height - lineLen),
        color,
        2
    );
}

function contours(vSrc) {
    //TODO: runterrechnen
    const f = width / videoWidth;
    cv.resize(vSrc, src, new cv.Size(width, height), f, f);

    cv.cvtColor(src, dstC1, cv.COLOR_RGBA2GRAY);
    cv.adaptiveThreshold(dstC1, dstC4, 255, cv.ADAPTIVE_THRESH_GAUSSIAN_C, cv.THRESH_BINARY, 11, -5);
    //cv.threshold(dstC1, dstC4, 130, 0, cv.THRESH_TRUNC);
    let contours  = new cv.MatVector();
    let hierarchy = new cv.Mat();
    cv.findContours(dstC4, contours, hierarchy, Number(cv.RETR_CCOMP), Number(cv.CHAIN_APPROX_SIMPLE), {x: 0, y: 0});

    dstC3.delete();
    dstC3 = new cv.Mat(height, width, cv.CV_8UC3);
    dstC3_.delete();
    dstC3_ = new cv.Mat(height, width, cv.CV_8UC3);
    cv.cvtColor(src, dstC3, cv.COLOR_RGBA2RGB);

    

    //
    //draw focus area
    const xOffset = 10;
    const aspectRatio = 0.7;
    const h = (width - 2*xOffset) * aspectRatio;
    //xOffset
    const focusRect = {
        x: xOffset,
        width: width - 2 * xOffset,
        y: (height - h) / 2,
        height: h
    }

    if (showHighResVideo) {
        cv.cvtColor(vSrc, vDstC3, cv.COLOR_RGBA2RGB);
        drawFocusRect(vDstC3, {
            x: focusRect.x / f,
            width: focusRect.width / f,
            y: focusRect.y / f,
            height: focusRect.height / f
        });
    } else {
        drawFocusRect(dstC3, focusRect);
    }
    


    
    let remainingIndices = [];
    let minSize = Math.min(width, height) * minSizeFactor;
    for (let i = 0; i<contours.size(); ++i)
    {
        let c = contours.get(i);
        let r = cv.boundingRect(c);
        if (r.width < minSize || r.height < minSize) continue;
        let a = cv.contourArea(c);
        //find rectangle-like contours
        if (a < r.width * r.height * areaFactor) continue;
        remainingIndices.push(i);
        c.delete();
        
    }

    let removeIndices = [];
    for (let j = 0; j < remainingIndices.length; j++) {
        let i0 = remainingIndices[j];
        if (removeIndices.includes(i0)) continue;
        for (let k = j + 1; k < remainingIndices.length; k++) {
            let i1 = remainingIndices[k];
            if (removeIndices.includes(i1)) continue;

            let c0 = contours.get(i0); let c1 = contours.get(i1);
            let r0 = cv.boundingRect(c0); let r1 = cv.boundingRect(c1);
            c0.delete(); c1.delete();

            let m0x = r0.x + r0.width/2;
            let m0y = r0.y + r0.height/2;
            //console.log(k);
            if (r1.x < m0x && m0x < r1.x + r1.width && r1.y < m0y && m0y < r1.y + r1.height) {
                if (r0.width * r0.height > r1.width * r1.height) {
                    removeIndices.push(i1);
                } else {
                    removeIndices.push(i0);
                    break;
                }
            }
        }
    }

    //remove indices out of focus area:
    for (let j = 0; j < remainingIndices.length; j++) {
        let i = remainingIndices[j];
        if (removeIndices.includes(i)) continue;
        let c = contours.get(i);
        let r = cv.boundingRect(c);
        if (r.x < focusRect.x || r.y < focusRect.y 
            || r.y + r.height > focusRect.y + focusRect.height 
            || r.x + r.width > focusRect.x + focusRect.width
            ) {
                removeIndices.push(i);
            }
        c.delete();
    }

    remainingIndices = remainingIndices.filter(j => !removeIndices.includes(j));

    //merge filter
    for (let j = 0; j<remainingIndices.length; j++) {
        let i = remainingIndices[j];
        cv.drawContours(dstC3, contours, i, contourColor, 1, cv.LINE_8, hierarchy);
    }

    function finializeUndetected() {
        contours.delete(); hierarchy.delete(); 
        return { image: showHighResVideo ? vDstC3 : dstC3, detected: false };
    }

    const grid = detectedGrids.find(g => g.x * g.y === remainingIndices.length);
    if (grid !== undefined) {

        //TODO: find bounding box
        
        let midPoints = [];
        let boundingBox = { xMin: width, yMin: height, yMax: 0, xMax: 0 };
        for (let j = 0; j<remainingIndices.length; j++) {
            let i = remainingIndices[j];
            let c = contours.get(i);
            let M = cv.moments(c, true);
            let r = cv.boundingRect(c);
            
            boundingBox.xMin = Math.min(r.x, boundingBox.xMin); boundingBox.xMax = Math.max(r.x + r.width, boundingBox.xMax);
            boundingBox.yMin = Math.min(r.y, boundingBox.yMin); boundingBox.yMax = Math.max(r.y + r.height, boundingBox.yMax);
            midPoints.push({ x: M.m10/M.m00, y: M.m01/M.m00, i: i }); 
            c.delete();
        }

        //check if there is a midpoint in every grid element
        //let allGridIn = [...Array(grid.x * grid.y).keys()];
        
        let midPointGridIndices = midPoints.map((p) => {
            let ix = Math.floor((p.x - boundingBox.xMin) / (boundingBox.xMax - boundingBox.xMin) * grid.x);
            let iy = Math.floor((p.y - boundingBox.yMin) / (boundingBox.yMax - boundingBox.yMin) * grid.y);
            return ix + grid.x * iy;
        });
        let indexSet = new Set(midPointGridIndices);
        //console.log(indexSet);
        //console.log(indexSet.size);
        if (indexSet.size !== midPoints.length) {
            return finializeUndetected();
        }

        //detected ui!
        
        if (firstDetection && performance.now() - firstDetection < 1000) {
            //ignore
            return finializeUndetected();
        }
        if (!firstDetection || performance.now() - firstDetection > 2000) {
            firstDetection = performance.now();
            return finializeUndetected();
        }

        let sortedPoints = midPoints.sort((pl, pr) => pl.x - pr.x);
        let left = sortedPoints.slice(0, grid.y).sort((pl, pr) => pl.y - pr.y);
        let topLeft = left[0];
        let bottomLeft = left[grid.y - 1];

        let right = sortedPoints.slice(sortedPoints.length - grid.y, sortedPoints.length).sort((pl, pr) => pl.y - pr.y);
        let topRight = right[0];
        let bottomRight = right[grid.y - 1];

        let c1 = contours.get(topLeft.i); let r1 = cv.boundingRect(c1); c1.delete();
        let c2 = contours.get(topRight.i); let r2 = cv.boundingRect(c2); c2.delete();
        let c3 = contours.get(bottomRight.i); let r3 = cv.boundingRect(c3); c3.delete();
        let c4 = contours.get(bottomLeft.i); let r4 = cv.boundingRect(c4); c4.delete();
        
        let p11 = { x: r1.x + r1.width / 2, y: r1.y };
        let p12 = { x: r2.x + r2.width / 2, y: r2.y };
        let p21 = { x: r2.x + r2.width, y: r2.y + r2.height / 2 };
        let p22 = { x: r3.x + r3.width, y: r3.y + r3.height / 2 };
        let p31 = { x: r3.x + r3.width / 2, y: r3.y + r3.height };
        let p32 = { x: r4.x + r4.width / 2, y: r4.y + r4.height };
        let p41 = { x: r4.x, y: r4.y + r4.height / 2 };
        let p42 = { x: r1.x, y: r1.y + r1.height / 2 };

        function intersection(p1, p2, p3, p4) {
            let x1 = p1.x; let y1 = p1.y;
            let x2 = p2.x; let y2 = p2.y;
            let x3 = p3.x; let y3 = p3.y;
            let x4 = p4.x; let y4 = p4.y;

            let x = ((x4-x3) * (x2*y1-x1*y2) - (x2-x1) * (x4*y3-x3*y4)) / ((y4-y3) * (x2-x1) - (y2-y1) * (x4-x3));
            let y = ((y1-y2) * (x4*y3-x3*y4) - (y3-y4) * (x2*y1-x1*y2)) / ((y4-y3) * (x2-x1) - (y2-y1) * (x4-x3));
            return { x: x, y: y };
        }

        //sort contours by mid x
        let p1 = intersection(p11, p12, p21, p22);
        let p2 = intersection(p21, p22, p31, p32);
        let p3 = intersection(p31, p32, p41, p42);
        let p4 = intersection(p41, p42, p11, p12);

        

        /*cv.line(dstC3, 
            new cv.Point(p4.x, p4.y),
            new cv.Point(p1.x, p1.y),
            [0, 255, 0, 0]
        );

        cv.line(dstC3, 
            new cv.Point(p1.x, p1.y),
            new cv.Point(p2.x, p2.y),
            [0, 255, 0, 0]
        );

        cv.line(dstC3, 
            new cv.Point(p2.x, p2.y),
            new cv.Point(p3.x, p3.y),
            [0, 255, 0, 0]
        );

        cv.line(dstC3, 
            new cv.Point(p3.x, p3.y),
            new cv.Point(p4.x, p4.y),
            [0, 255, 0, 0]
        );*/

        let dstWidth = videoWidth;
        let dstHeight = videoWidth / grid.wh // 4x2 layout propotions

        let f = videoWidth / width;
        let points = [p1.x*f, p1.y*f, p2.x*f, p2.y*f, p3.x*f, p3.y*f, p4.x*f, p4.y*f];
        const sourceMat = cv.matFromArray(4, 2, cv.CV_32F, points);
        let target = [
            dstWidth, 0.0,
            dstWidth, dstHeight,
            0.0, dstHeight,
            0.0, 0.0, 
        ]

        const targetMat = cv.matFromArray(4, 2, cv.CV_32F, target);
        let h = cv.findHomography(sourceMat, targetMat);
        cv.warpPerspective(vSrc, vDstC3, h, new cv.Size(dstWidth, dstHeight));

        contours.delete(); hierarchy.delete(); 
        return { image: vDstC3, detected: true, grid: grid };
    }

    return finializeUndetected();
}

export function init(w, h) {
    videoWidth = w;
    videoHeight = h;
    width = 320.0;
    height = width / videoWidth * h;
    dstC1 = new cv.Mat(height, width, cv.CV_8UC1);
    dstC3 = new cv.Mat(height, width, cv.CV_8UC3);
    dstC3_ = new cv.Mat(height, width, cv.CV_8UC3);
    dstC4 = new cv.Mat(height, width, cv.CV_8UC4);
    src = new cv.Mat(height, width, cv.CV_8UC3);
    vDstC3 = new cv.Mat(videoHeight, videoWidth, cv.CV_8UC3);
}

export default function processImage(src) {
    let result = contours(src);
    return result;
}
